<template>
  <v-dialog
    v-model="showPopup"
    persistent
    max-width="520"
    @keydown.passive.enter='doSave'
    @keydown.passive.esc='$emit("cancel")'>
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        {{ isEdit ? 'Edit' : 'Add New' }}
        <span v-if="item.type == 'rack'">Rack</span>
        <span v-else-if="item.type == 'shelf'">Shelf</span>
        <span v-else-if="item.type == 'bin'">Bin</span>
        {{ isEdit ? 'Label' : ''}}
      </v-card-title>
      <v-card-text>
        <div style="max-width: 300px; margin: 0 auto">
          <div class="input-mb input-box">
            <v-text-field
              dense
              placeholder="Enter Label"
              v-model="label"
              :rules="labelRules"
              maxlength="128"
              required
              class="r-field item-name-field"
              @keyup="validate"
            />
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="$emit('cancel')"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="doSave"
          depressed
          class="save-btn small-size"
          :disabled="!valid"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WarehouseMapAddEditPopup',
  props: {
    showPopup: {
      type: Boolean,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      label: '',
      labelRules: [
        v => !!v.length || 'Label is required'
      ],
      valid: false
    }
  },
  computed: {
    isEdit() {
      return !!this.item?.original?.id
    }
  },
  created() {
    this.label = this.item.original.label
  },
  methods: {
    async doSave() {
      this.item.original.label = this.label
      this.$emit('save')
    },
    validate() {
      this.valid = true
      const label = this.label.trim().toUpperCase()
      if (!label) {
        this.valid = false
      }

      if (this.item.type === 'rack') {
        this.valid = !this.items.find(rack => rack.original.label.toUpperCase() === label)
      }

      if (this.item.type === 'shelf') {
        const rack = this.items.find(rack => rack.id === this.item.original.rackId)
        if (!rack) {
          this.valid = false
        }
        this.valid = !rack.original.shelves.find(shelf => shelf.label.toUpperCase() === label)
      }

      if (this.item.type === 'bin') {
        const rack = this.items.find(rack => rack.id === this.item.original.rackId)
        if (!rack) {
          this.valid = false
        }
        const shelf = rack.original.shelves.find(shelf => shelf.id === this.item.original.shelfId)
        if (!shelf) {
          this.valid = false
        }
        this.valid = !shelf.bins.find(bin => bin.label.toUpperCase() === label)
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
